import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { IKeypadModal, KeypadModal } from 'src/common/components/keypad-modal/keypad-modal';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import NumberInputField from 'src/number-input-field';
import { transactionSearchModalStyles } from '../../transaction-based-return-styles';

export const TBR_QUANTITY_MODAL = 'TBR_QUANTITY_MODAL';

export const showTbrQuantityModal = (props: ITBRQuantityModalProps) => {
  pushEmeraldModal(<TBRQuantityModal {...props} />, undefined, TBR_QUANTITY_MODAL);
};

export const closeTbrQuantityModal = (): void => {
  popEmeraldModal(TBR_QUANTITY_MODAL);
};

const TBRQuantityModal = ({
  onClose,
  onApprove,
  givenMax,
}: ITBRQuantityModalProps): JSX.Element => {
  const [returnQty, setReturnQty] = useState<number>(givenMax);
  const classes = transactionSearchModalStyles();
  const { t } = useTranslation();

  const keypadSubmitButton: IButton = {
    label: t('Ok'),
    onClick: quantity => {
      if (quantity && Number(quantity) <= givenMax) {
        setReturnQty(Number(quantity));
      }
      onApprove(`${quantity ? quantity : returnQty}`);
    },
  };

  const keypadModal: IKeypadModal = {
    onClose: onclose,
    title: '',
    iconType: EmeraldDialogTypes.InfoDecision,
    buttonComponent: (
      <Grid item>
        <BaseButton
          buttonType='white'
          className={classes.rejectButton}
          data-testid='tbr-quantity-modal-cancel-button'
          onClick={onClose}
        >
          <span className='label'>{t('Cancel_Button')}</span>
        </BaseButton>
      </Grid>
    ),
    contentArea: (
      <Grid className={classes.alignCenter}>
        <Typography className={classes.modalText}>
          {t('TransactionBasedReturnQuantityPickerView_HowManyItems')}
        </Typography>
        <Grid item className={classes.qtyCenter}>
          <NumberInputField
            value={returnQty}
            minimum={1}
            handleChange={setReturnQty}
            disabled={false}
            bigSize={true}
            givenMax={givenMax}
          />
        </Grid>
      </Grid>
    ),
    keypad: (
      <Keypad
        keyboardId={'tbr-quantity-modal'}
        visible
        keypadTestIdPrefix={'tbr-quantity-modal-'}
        topLabelText={t('TransactionBasedReturnQuantityPickerView_KeypadText')}
        submitButton={keypadSubmitButton}
        disableManualWeight={true}
        disableQuantity={true}
        disableDecimalInput={true}
        isPriceMode={true}
      />
    ),
  };

  return <KeypadModal {...keypadModal} />;
};

export interface ITBRQuantityModalProps {
  onClose: () => void;
  onApprove: (newQuantity: string) => void;
  givenMax: number;
}

export default TBRQuantityModal;
